import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';

import ListHeader from 'components/form/ListHeader';


import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import SettingCollectionFee from './components/SettingCollectionFee';
import SettingStateCost from './components/SettingStateCost';
import SettingTransactionKeyGroup from './components/SettingTransactionKeyGroup';
import SettingInterest from './components/SettingInterest';
import SettingCostTransactionKey from './components/SettingCostTransactionKey';
import SettingYesNo from './components/SettingYesNo';
import SettingNumber from './components/SettingNumber';
import SettingText from './components/SettingText';
import SettingTransactionKey from './components/SettingTransactionKey';
import SettingRegex from './components/SettingRegex';
import SettingCurrency from './components/SettingCurrency';
import SettingForm from './components/SettingForm';
import SettingVAT from './components/SettingVAT';
import SettingCapitalGainsTax from './components/SettingCapitalGainsTax';
import SettingClaimStatus from './components/SettingClaimStatus';
import SettingClaimOrigin from './components/SettingClaimOrigin';
import SettingRadioButton from './components/SettingRadioButton';
import SettingClaimCancel from './components/SettingClaimCancel';



const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const HANDLED_INPUT_TYPES = [1, 2, 3, 5, 10, 12, 13, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 26];

export const SettingList = ({ }) => {
  const [list, setList] = useState([]);
  const [lookup, setLookup] = useState({
    transactionGroupList: [],
    ownerTypeList: [],
    collectionFeeList: [],
    currencyList: [],
    vatList: [],
    capitalgainstaxList: [],
    interestList: [],
    indexList: [],
    claimoriginList: [],
    formList: [],
    claimstatusList: [],
    documentedcancelationreasonList: [],
    collectionDataHandlingList: [],
    cancellationReasonList: []
  });
  const [tabSelected, setTabSelected] = useState(0);

  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  const loadLookup = async () => {
    let [transactionGroupList, transactionKeyList, collectionFeeList, currencyList, vatList, capitalgainstaxList, interestList, indexList, claimoriginList, formList, claimstatusList, documentedcancelationreasonList, collectionDataHandlingList, cancellationReasonList] = await Promise.all([
      apiGetCall(BASE_URL + '/admin/list/transactionkeygroup'),
      apiGetCall(BASE_URL + '/admin/list/transactionkey'),
      apiGetCall(BASE_URL + '/admin/list/collectionfee'),
      apiGetCall(BASE_URL + '/admin/list/currency'),
      apiGetCall(BASE_URL + '/admin/list/vat'),
      apiGetCall(BASE_URL + '/admin/list/capitalgainstax'),
      apiGetCall(BASE_URL + '/admin/list/interesttable'),
      apiGetCall(BASE_URL + '/admin/list/indextable'),
      apiGetCall(BASE_URL + '/admin/list/claimorigin'),
      apiGetCall(BASE_URL + '/admin/list/form'),
      apiGetCall(BASE_URL + '/admin/list/claimstatus'),
      apiGetCall(BASE_URL + '/admin/claim/documentedCancellationReasons'),
      apiGetCall(BASE_URL + '/admin/claim/collectionDataHandlings'),
      apiGetCall(BASE_URL + '/admin/claim/cancellationReasons')
    ]);




    //Check we need to display any critical errors.
    setCheckErrorItems([transactionGroupList, transactionKeyList, collectionFeeList, currencyList, vatList, capitalgainstaxList, interestList, indexList, claimoriginList, formList, claimstatusList, documentedcancelationreasonList, collectionDataHandlingList, cancellationReasonList]);

    var lookupData = {
      transactionGroupList: transactionGroupList,
      transactionKeyList: transactionKeyList,
      collectionFeeList: collectionFeeList,
      currencyList: currencyList,
      vatList: vatList,
      capitalgainstaxList: capitalgainstaxList,
      interestList: interestList,
      indexList: indexList,
      claimoriginList: claimoriginList,
      formList: formList,
      claimstatusList: claimstatusList,
      documentedcancelationreasonList: documentedcancelationreasonList,
      collectionDataHandlingList: collectionDataHandlingList,
      cancellationReasonList: cancellationReasonList
    };
    //Translate the data into what we want to use.
    setLookup(lookupData);
    // console.log("Loook", lookupData);

  }

  const loadList = async () => {
    setIsPageLoading(true);
    const data = await apiGetCall(BASE_URL + '/admin/setting');
    if (isResultOk(data, setCheckErrorItems)) {
      // console.log("setting", data);
      setList(data);
    }
    setIsPageLoading(false);
  }

  useEffect(() => {
    loadLookup();
    loadList();
  }, []);


  const onDeleteClick = async (transactionGroupID) => {
    setIsPageLoading(true);
    const data = await apiPostCall(BASE_URL + '/admin/actioncost/remove', { itemID: transactionGroupID });
    if (isResultOk(data, setCheckErrorItems)) {
      await loadList();
    }
    setIsPageLoading(false);
  }





  const listStyle = {
    listStyle: "none"
  }

  return (
    <div>
      <ListHeader title={t("Stillingar")}>
        {t("Viðvörun, breytingar á stillingum getur haft mikil áhrif á virkni kerfisins.")}
      </ListHeader>

      <Tabs selectedIndex={tabSelected} onSelect={(index) => setTabSelected(index)}>
        <TabList>
          {list.map((category, catidx) =>
            <Tab key={catidx}>{category.name}</Tab>
          )}
        </TabList>
        {list.map((category, catidx) =>
          <TabPanel key={"tab" + catidx}>
            <div className="ci-animate-repeat">
              {category.groups.map((group, grpidx) =>
                <ul key={catidx + "-" + grpidx} className="ci-animate-repeat" style={listStyle}>
                  <h3>{group.name}</h3>
                  {group.definitions.map((def, defidx) =>
                    <li key={catidx + "-" + grpidx + "-" + defidx} className=" ci-animate-repeat" style={listStyle}>
                      {def.inputTypeID === 1 && <SettingText definition={def} />}
                      {def.inputTypeID === 2 && <SettingYesNo definition={def} />}
                      {def.inputTypeID === 3 && <SettingRadioButton definition={def} />}
                      {def.inputTypeID === 5 && <SettingNumber definition={def} />}
                      {def.inputTypeID === 17 && <SettingRegex definition={def} />}

                      {def.inputTypeID === 21 && <SettingVAT definition={def} vatList={lookup.vatList} />}
                      {def.inputTypeID === 22 && <SettingCapitalGainsTax definition={def} capitalgainstaxList={lookup.capitalgainstaxList} />}

                      {def.inputTypeID === 23 && <SettingClaimOrigin definition={def} claimOriginList={lookup.claimoriginList} />}
                      {def.inputTypeID === 24 && <SettingClaimStatus definition={def} claimStatusList={lookup.claimstatusList} />}

                      {def.inputTypeID === 20 && <SettingForm definition={def} formList={lookup.formList} />}
                      {def.inputTypeID === 19 && <SettingCurrency definition={def} currencyList={lookup.currencyList} />}
                      {def.inputTypeID === 13 && <SettingInterest definition={def} interestList={lookup.interestList} />}
                      {def.inputTypeID === 10 && <SettingCostTransactionKey definition={def} transactionKeyList={lookup.transactionKeyList} />}
                      {def.inputTypeID === 12 && <SettingStateCost definition={def} transactionKeyList={lookup.transactionKeyList} />}
                      {def.inputTypeID === 15 && <SettingTransactionKey definition={def} transactionKeyList={lookup.transactionKeyList} />}
                      {def.inputTypeID === 16 && <SettingTransactionKeyGroup definition={def} transactionGroupList={lookup.transactionGroupList} />}
                      {def.inputTypeID === 18 && <SettingCollectionFee definition={def} collectionFeeList={lookup.collectionFeeList} />}
                      {def.inputTypeID === 26 && <SettingClaimCancel definition={def} documentedcancelationreasonList={lookup.documentedcancelationreasonList} collectionDataHandlingList={lookup.collectionDataHandlingList} cancellationReasonList={lookup.cancellationReasonList} />}
                      {!HANDLED_INPUT_TYPES.includes(def.inputTypeID) && <div>*** {def.name} ***</div>}
                    </li>
                  )}
                </ul>
              )}
            </div>
          </TabPanel>
        )}
      </Tabs>
    </div>
  );
};

